/* src/app/modules_v2/booking/locations/components/sections/location-reviews-section/location-reviews-section.component.css */
.reviews-section {
  padding: 1rem 1.25rem;
}
.scope-tabs {
  display: inline-flex;
  gap: 0.25rem;
  border: 1px solid #e5e7eb;
  border-radius: 999px;
  padding: 0.2rem;
  background: #f9fafb;
}
.scope-tab {
  background: none;
  border: 0;
  padding: 0.45rem 1rem;
  border-radius: 999px;
  cursor: pointer;
  color: #4b5563;
  font-weight: 600;
}
.scope-tab.active {
  background: #f6c000;
  color: #111827;
}
.filter-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
}
.filter-row label {
  display: inline-flex;
  gap: 0.4rem;
  align-items: center;
  font-size: 0.9rem;
  color: #374151;
}
.filter-row .filter-label {
  font-weight: 600;
}
.filter-row select {
  padding: 0.4rem 0.6rem;
  border: 1px solid #d1d5db;
  border-radius: 8px;
}
.total {
  color: #6b7280;
  font-size: 0.9rem;
}
.empty-state {
  background: #f9fafb;
  border: 1px dashed #e5e7eb;
  border-radius: 12px;
  padding: 2rem;
  text-align: center;
  color: #6b7280;
}
.empty-state mat-icon {
  font-size: 2rem;
  height: 2rem;
  width: 2rem;
  margin-bottom: 0.5rem;
  color: #9ca3af;
}
.empty-state p {
  margin: 0;
}
.review-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
.review-item {
  background: #fff;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 1rem 1.25rem;
}
.review-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0.75rem;
  flex-wrap: wrap;
}
.author {
  display: flex;
  gap: 0.6rem;
  align-items: center;
}
.author .avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: #e5e7eb center/cover no-repeat;
  color: #4b5563;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  flex-shrink: 0;
}
.author small {
  display: block;
  color: #6b7280;
  font-size: 0.8rem;
}
.status-block {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  gap: 0.3rem;
}
.rating-stars {
  display: inline-flex;
}
.rating-icon {
  color: #f59e0b;
  font-size: 1.1rem;
  height: 1.1rem;
  width: 1.1rem;
}
.status-badge {
  font-size: 0.75rem;
  padding: 0.15rem 0.55rem;
  border-radius: 999px;
  background: #ecfdf5;
  color: #047857;
  font-weight: 600;
}
.status-badge.warn {
  background: #fef3c7;
  color: #92400e;
}
.status-badge.muted {
  background: #f3f4f6;
  color: #4b5563;
}
.comment {
  color: #374151;
  line-height: 1.5;
  margin: 0.75rem 0 0.5rem;
}
.actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
  flex-wrap: wrap;
}
.btn-link {
  background: none;
  border: 0;
  cursor: pointer;
  color: #1d4ed8;
  font-weight: 600;
  padding: 0.25rem 0.5rem;
  font-size: 0.85rem;
  border-radius: 6px;
}
.btn-link:hover:not(:disabled) {
  background: #eff6ff;
}
.btn-link.danger {
  color: #b91c1c;
}
.btn-link:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.response-block {
  background: #f9fafb;
  border-left: 3px solid #f6c000;
  padding: 0.75rem 1rem;
  margin: 0.75rem 0 0;
  border-radius: 6px;
}
.response-block strong {
  color: #92400e;
  font-size: 0.85rem;
}
.response-block p {
  margin: 0.3rem 0;
  line-height: 1.4;
}
.response-block small {
  color: #6b7280;
  font-size: 0.75rem;
}
.response-editor {
  margin-top: 0.75rem;
}
.response-editor textarea {
  width: 100%;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 0.6rem;
  font-family: inherit;
  font-size: 0.95rem;
  resize: vertical;
}
.response-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
}
.btn-primary {
  background: #f6c000;
  color: #111827;
  border: 0;
  padding: 0.5rem 1rem;
  border-radius: 8px;
  cursor: pointer;
  font-weight: 700;
}
.btn-primary:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}
.pagination {
  display: flex;
  gap: 1rem;
  align-items: center;
  justify-content: center;
  margin-top: 1.5rem;
  color: #4b5563;
  font-size: 0.9rem;
}
/*# sourceMappingURL=location-reviews-section.component.css.map */
